var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.class_list},[_c('span',[_vm._v(" "+_vm._s(_vm.snackbar_options.error.text)+" ")]),_c('button',{staticClass:"dismiss-btn",on:{"click":_vm.dismiss}},[_vm._v("Dismiss")])])
}
var staticRenderFns = []

export { render, staticRenderFns }